export const CALENDAR_RIGHTS = ['calendar.view'];
export const PURCHASE_ORDERS_RIGHTS = ['purchaseorders.view'];
export const RECEIPT_RIGHTS = [
  'receipts.view',
  'receipts.create',
  'receipts.edit',
  'receipts.delete',
  'receipts.restore',
];
export const ORDER_RIGHTS = [
  'orders.view',
  'orders.create',
  'orders.edit',
  'orders.delete',
  'orders.ship',
];
export const FREIGHT_RIGHTS = ['freight.view'];
export const EORDER_RIGHTS = ['eorders.view'];
export const CLIENTS_RIGHTS = ['clients.view'];
export const INVENTORY_RIGHTS = ['inventory.view', 'inventory.adjust'];
export const PICKING_RIGHTS = ['picking.view'];
export const ITEM_RIGHTS = ['items.view', 'items.manage'];
export const WAREHOUSE_RIGHTS = ['warehouse.view'];
export const INVOICE_RIGHTS = [
  'invoices.view',
  'invoices.create',
  'invoices.edit',
  'invoices.delete',
];
export const PAYMENT_RIGHTS = [
  'payments.view',
  'payments.create',
  'payments.edit',
  'payments.delete',
];
export const INVOICING_RIGHTS = [...INVOICE_RIGHTS, ...PAYMENT_RIGHTS];
export const REPORT_RIGHTS = ['reports.view', 'reports.export'];

const CLIENT_SELF_SERVICE_RIGHTS = new Set([
  ...EORDER_RIGHTS,
  ...INVENTORY_RIGHTS,
  ...ITEM_RIGHTS,
]);

function isClientUser(user = {}) {
  const truthy = (value) => {
    if (value === true || value === 1) return true;
    const text = String(value ?? '').trim().toLowerCase();
    return text === '1' || text === 'true' || text === 'yes' || text === 'y';
  };
  const directRoles = [
    user?.role,
    user?.roleid,
    user?.userrole,
    user?.type,
    user?.usertype,
    user?.userType,
  ];
  const roleHit =
    directRoles.some((value) => String(value ?? '').trim().toLowerCase() === 'client') ||
    (Array.isArray(user?.roles) && user.roles.some((value) => String(value ?? '').trim().toLowerCase() === 'client'));
  return (
    truthy(user?.isclient) ||
    truthy(user?.isClient) ||
    truthy(user?.client) ||
    truthy(user?.clientuser) ||
    roleHit
  );
}

export function hasAnyRight(userOrRights, required = []) {
  const rights = Array.isArray(userOrRights)
    ? userOrRights
    : (Array.isArray(userOrRights?.rights) ? userOrRights.rights : null);

  // Back-compat: if rights are missing from the stored user, do not hide or block.
  if (!Array.isArray(rights)) return true;
  if (rights.includes('*')) return true;

  const needed = Array.isArray(required) ? required : [required];
  if (!needed.length) return true;
  if (
    !Array.isArray(userOrRights) &&
    isClientUser(userOrRights) &&
    needed.some((right) => CLIENT_SELF_SERVICE_RIGHTS.has(right))
  ) {
    return true;
  }
  return needed.some((right) => rights.includes(right));
}
